module.exports = "/static/img/we_work_with_2.svg?0329fc13efc9996527698468453be083";